module.exports = __webpack_public_path__ + "static/media/img.52f61856.svg";